export default {"src":"/_next/static/image/public/assets/platform-logos/chrome.1bffca36b067e00ee22c9da80ab3cfff.svg","height":176,"width":176};